<div class="container">
  <div class="row">
    <h1 class="big-title">About Me:</h1>
    <div class="showRow p-3 col-12">
      <img class="round-img mx-3" src="assets/images/me.png" align="left">
      <div class="my-4">
        <div>I am a (really) small German Youtuber / mapmaker.</div>
        <div>On my Channel I am not only doing Survival Let's plays but also these "Feature" Videos where I program new things into the game and see how they would look in Minecraft.</div>
        <div>When I am playing Minecraft this is mostly what I do. I play around with new concepts, create new minigames, recreate old minigames and just have fun with data packs.</div>
        <div>I am also enjoying doing things with resource packs and 3d Modeling for Minecraft.</div>
      </div>
    </div>
  </div>
  <div class="row">
    <h1 class="big-title">Projects:</h1>
    <div *ngFor="let project of Projects" class="col">
      <app-project-card [project]="project" class="px-2"></app-project-card>
    </div>
  </div>
  <div class="row">
    <h1 class="big-title">Resource Packs:</h1>
    <div *ngFor="let resource of Resources" class="col">
      <app-project-card [project]="resource" class="px-2"></app-project-card>
    </div>
    <!--<div class="col-12">
      <p>Send your packs to me: <a href="https://docs.google.com/forms/d/e/1FAIpQLSeX4bO15h9PTy9DT55fNzw5MChejXZynBXtnZum1MIy-Tnimw/viewform?usp=sf_link">[Click Here]</a> </p>
    </div>-->
  </div>
  <div class="row">
    <h1 class="big-title">Data Packs:</h1>
    <div *ngFor="let datapack of Datapacks" class="col">
      <app-project-card [project]="datapack" class="px-2"></app-project-card>
    </div>
    <!--<div class="col-12">
      <p>Send your packs to me: <a href="https://docs.google.com/forms/d/e/1FAIpQLSeX4bO15h9PTy9DT55fNzw5MChejXZynBXtnZum1MIy-Tnimw/viewform?usp=sf_link">[Click Here]</a> </p>
    </div>-->
  </div>
  <!--  <div class="row">
      <h1 class="big-title">My Videos:</h1>
    </div>
    <div class="row">
      <iframe class="video" src="http://www.youtube.com/embed?listType=playlist&list=PLFdyQbocEXk-YTsiEyK5f7zkJf2yrtW2L" width="1600" height="600"></iframe>
    </div>-->
</div>
